/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\mixins\checkFieldHide.js                                         *
 * Project: frontend                                                           *
 * Created Date: Wednesday, November 8th 2023, 11:47:14 am                     *
 * Author: Prudhvi Teja <prudhvi@codestax.ai>                                  *
 * -----                                                                       *
 * Last Modified: November 14th 2023, 1:31:55 pm                               *
 * Modified By: Prudhvi Teja                                                   *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

import { getFromLocalStorage } from '../store/localStorageInterface';
export const checkFieldHide = {
    inheritAttrs: false,
    methods: {
        checkFieldHide(type, fieldItem, workFlowId = '' ,currentStage = '') {
            if ((type === 'ADD'|| type === 'UPDATE') && fieldItem.field_access && fieldItem.field_access.hide) {
                if (
                    fieldItem.field_access.hide['default'] &&
                    fieldItem.field_access.hide['default'].includes(getFromLocalStorage('userGroup'))
                ) {
                    return false;
                } else if (workFlowId && fieldItem.field_access.hide[workFlowId] && fieldItem.field_access.hide[workFlowId]['defaultStage'] &&
                    fieldItem.field_access.hide[workFlowId]['defaultStage'].includes(getFromLocalStorage('userGroup'))
                ) {
                    return false;
                }
            }
            if (
                (type === 'STAGEUPDATE' || type === 'UPDATE') &&
                workFlowId && 
                currentStage &&
                fieldItem.field_access &&
                fieldItem.field_access.hide &&
                fieldItem.field_access.hide[workFlowId] &&
                fieldItem.field_access.hide[workFlowId][currentStage] &&
                fieldItem.field_access.hide[workFlowId][currentStage].includes(getFromLocalStorage('userGroup'))
            ) {
                return false;
            }
            return true;
        }
    }
};
